import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { AuthButtons } from "@web/components/AuthButtons";
import { Navbar } from "@web/components/Navbar";
import { AnnouncementBanner } from "@web/route-services/index/AnnouncementBanner";
import { Explore } from "@web/route-services/index/Explore";
import { Featured } from "@web/route-services/index/Featured";
import { Footer } from "@web/route-services/index/Footer";
import { Header } from "@web/route-services/index/Header";
import { searchSchema } from "@web/route-services/index/utils";
import { useAppContext } from "@web/route-services/root/AppContext";
import { motion } from "motion/react";

export const Route = createFileRoute("/")({
  component: IndexPage,
  validateSearch: searchSchema
});

function IndexPage() {
  const { isDesktopScreen, session } = useAppContext();
  const navigate = useNavigate();
  const { searchText, tags } = Route.useSearch();
  const date = "06/15";
  const description = "Minor: Perf Patch";

  const src = "/banner-2025-06-15.webp";

  const isSearching = searchText || tags?.length;

  if (isDesktopScreen) {
    return (
      <div className="from-background-gradient via-background to-background text-tx-primary flex h-screen w-screen bg-gradient-to-b antialiased">
        <Navbar />
        <div
          style={{ scrollbarGutter: "stable" }}
          className="scroll-home-page ml-2.5 flex w-full flex-col overflow-auto p-8"
        >
          <Header />
          <div className="flex flex-col space-y-14">
            {!isSearching && (
              <>
                <AnnouncementBanner
                  src={src}
                  className="mb-12 cursor-pointer"
                  onClick={() => navigate({ to: "/changelog" })}
                >
                  <div className="font-display text-tx-primary absolute inset-0 flex select-none flex-col items-center justify-center p-8 text-6xl">
                    <span className="font-bold">
                      {date} | {description}
                    </span>
                  </div>
                </AnnouncementBanner>

                <Featured />
              </>
            )}
            <Explore />
          </div>
          <AnnouncementBanner
            src={"banner-pistol.webp"}
            onClick={() => {
              window.open("https://discord.gg/CNGAZrahmA", "_blank");
            }}
            className="mt-20 cursor-pointer p-2"
          >
            <div className="font-display text-tx-primary absolute inset-0 flex select-none flex-col items-center justify-center p-8 text-6xl">
              <div className="flex flex-col items-center">
                <span className="font-bold">{"Join The Discord"}</span>
                <span className="font-bold">{"Or Else..."}</span>
              </div>
            </div>
          </AnnouncementBanner>
          <Footer className="" />
        </div>
      </div>
    );
  }

  return (
    <>
      <Navbar />
      <Header />
      <div className="mt-24 flex flex-col space-y-12">
        {!isSearching && (
          <>
            <div className="flex flex-col">
              <AnnouncementBanner
                src={src}
                className="mb-3 cursor-pointer p-2"
                onClick={() => navigate({ to: "/changelog" })}
              >
                <div className="font-display text-tx-primary absolute inset-0 flex select-none flex-col items-center justify-center px-8 py-4 text-2xl">
                  <div className="flex flex-col items-center">
                    <span className="font-bold">{date}</span>
                    <span className="font-bold">{description}</span>
                  </div>
                </div>
              </AnnouncementBanner>
              {!session && (
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.6, duration: 0.3 }}
                  className="text-tx-primary"
                >
                  <AuthButtons />
                </motion.div>
              )}
            </div>
            <Featured />
          </>
        )}
        <Explore />
      </div>
      <AnnouncementBanner
        src={"banner-pistol.webp"}
        onClick={() => {
          window.open("https://discord.gg/CNGAZrahmA", "_blank");
        }}
        className="mt-7 cursor-pointer p-2"
      >
        <div className="font-display text-tx-primary absolute inset-0 flex select-none flex-col items-center justify-center px-8 py-4 text-2xl">
          <div className="flex flex-col items-center">
            <span className="font-bold">{"Join The Discord"}</span>
            <span className="font-bold">{"Or Else..."}</span>
          </div>
        </div>
      </AnnouncementBanner>
      <Footer className="mb-20 mt-10" />
    </>
  );
}
